import { styled } from 'styled-components'
import CancelIcon from '@mui/icons-material/Cancel';
import Button from '@mui/material/Button';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LoginIcon from '@mui/icons-material/Login';
import { useState } from 'react'
import fondo from '../../imgs/fondomenu.avif'
import {  user,userLogin } from '../../redux/actions/loginActions.js';
import { useDispatch } from 'react-redux';
import { loginUser } from '../../services/login.js'

const Container=styled.div`
 	
 	width:75vw;
 	height:340px;
 	border-radius:5px;
 	overflow:auto;
 	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}

 `;

const Close=styled.div`
	position:absolute;
	 top:21vh;
	 right:10vw;
	 width:35px;
	 font-size: 40px;
	 &:hover{
	 	color:black;
	 	cursor:pointer
	 }

`;

const BasicData=styled.div`
	position:relative;
	display:flex;
 	justify-content:space-around;
 	align-items:center;
 	background-color:white;
 	height:100%; 
 	border-radius:10px;
 	color:black; 
 	font-family:Roboto;
 	@media (max-width: 768px){
    	flex-direction: column;
    	background-size:cover;
    	s
  	};

`;

const ContainerMarca=styled.div`
	position:absolute;
	right:25px;
	top:25px;


`;

const ContainerCreateNuevaCuenta=styled.div`
	width:50%;
	height:100%;
	display:flex;
	flex-direction:column;
	align-items:center;
	justify-content:center;
	position:relative;
	@media (max-width: 768px){
    	width:100%;
  	}
`;

const Overlay2=styled.div`
	position:absolute;
	background-image:url(${fondo});
	background-size:38%;
	background-position:center;
	height:100%;
	width:100%;	
	opacity:0.07
	
`;

const ContainerLoginCuenta=styled.div`
	width:50%;
	height:100%;
	background-color:black;
	color:white;
	display:flex;
	flex-direction:column;
	align-items:center;
	@media (max-width: 768px){
    	width:100%;
  	}
`;

const Titulo=styled.div`
 font-size:20px;
 font-weight:bold;
 width: 85%;
 margin:40px;

`

const SubTitulo=styled.div`
 font-size:16px;
 width:80%;
 display:flex;
 justify-content:start;
 margin:15px;
`

const Descripcion=styled.div`
	font-size:15px;
	width:70%;
	display:flex;
	flex-direction:column
`

const ContainerBotonesAction=styled.div`
		width:100%;
		display:flex;
		justify-content:center;
		margin-top:55px;


`;

const DatosInicioSesion=styled.div`
	display:flex;
	align-items:center;
	justify-content:space-between;
	margin:15px;
	font-weight:bold


`

	

export default function LoginShoppingCart(props){
	let { close } = props;
	 const [showPassword, setShowPassword] = useState(false);
	 let [datos,setDatos]=useState({usuario:"",password:""});
	 let dispatch=useDispatch();
 
	let navigate=useNavigate();

	const handleClickShowPassword = () => setShowPassword((show) => !show);

  	

  	



 	let handleClickRegistrar=()=>{
 		navigate("/registro")
 	};

 	

 	let handleChange=(e)=>{
		setDatos({...datos,[e.target.id]:e.target.value });

	};
	

 	let validar=async()=>{
 		
		try{
			let validate=await loginUser(datos);
				dispatch(user(validate));
				dispatch(userLogin(true));
				setDatos({usuario:"",password:""});
				close(false)
									
				
		}catch(err){alert(err)}
	};


	const handleKeyPress = (e) => {
    		if (e.key === 'Enter') {
      				validar();
    		}
  	};
 	
 

	return(
		<Container>
			<Close onClick={close}><CancelIcon fontSize="50px"/></Close>
			
			<BasicData > 

				<ContainerCreateNuevaCuenta>
					<ContainerMarca><b>Playlan</b>myn™</ContainerMarca>
					<Overlay2/>
					<Titulo>Crear Cuenta Nueva </Titulo>
					<SubTitulo>- Crear una cuenta tiene muchos beneficios :</SubTitulo>
					<Descripcion>
						<div>te permitira acceder a los juegos mediante compra</div>
						<div>te permitira revender tus juegos</div>
						<div>te permitira acceder a promos</div>
						<ContainerBotonesAction>
							<Button onClick={handleClickRegistrar} variant="contained" size="large"  sx={{ backgroundColor: '#111111','&:hover':{backgroundColor: 'black'},}} endIcon={<PersonAddIcon />} >Crear Cuenta</Button>
						</ContainerBotonesAction>
					</Descripcion>
				</ContainerCreateNuevaCuenta>
					

				<ContainerLoginCuenta>
					<ContainerMarca><b>Playlan</b>myn™</ContainerMarca>
					<Titulo>Inicia Sesion  </Titulo>
					<Descripcion>
						<DatosInicioSesion>
							<label>USUARIO : </label>
							 <TextField id="usuario" onChange={handleChange} variant="standard" value={ datos.usuario}
							 	 InputProps={{
							 	endAdornment:(<InputAdornment position="end">
							 	<PersonIcon/>
							 </InputAdornment>)}}/>
							</DatosInicioSesion>
						<DatosInicioSesion>
							<label>	CONTRASEÑA :</label> 
							<TextField id="password"  variant="standard"  onKeyPress={handleKeyPress} value={ datos.password} onChange={handleChange} type={showPassword ? 'text' : 'password'} 
							InputProps={{
							 	endAdornment:(<InputAdornment position="end" onClick={handleClickShowPassword}>
							 	 {showPassword ? <VisibilityOff /> : <Visibility />}
							 </InputAdornment>)}}/>
						</DatosInicioSesion>
						<ContainerBotonesAction>
							<Button onClick={validar} variant="contained" size="large"  sx={{ backgroundColor: '#EDEBEB','&:hover':{backgroundColor: 'white'},color:"black"}} endIcon={<LoginIcon />} >iniciar sesion</Button>
						</ContainerBotonesAction>
					</Descripcion>
				</ContainerLoginCuenta>

			</BasicData>

		</Container>
		)
} 